import React from "react";
import { Bell, FileSpreadsheet, X } from "lucide-react";
import { Link } from "react-router-dom";

const DISMISS_KEY_PREFIX = "calins.admin.excelExportReminder.dismissed.";

function getLocalDateKey(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function isMonday(date = new Date()) {
  return date.getDay() === 1;
}

export default function WeeklyExcelExportReminder({ role }) {
  const todayKey = React.useMemo(() => getLocalDateKey(), []);
  const dismissKey = `${DISMISS_KEY_PREFIX}${todayKey}`;
  const [dismissed, setDismissed] = React.useState(() => {
    try {
      return window.localStorage.getItem(dismissKey) === "1";
    } catch {
      return false;
    }
  });

  if (role !== "admin" || !isMonday() || dismissed) return null;

  const dismiss = () => {
    try {
      window.localStorage.setItem(dismissKey, "1");
    } catch {
      // no-op
    }
    setDismissed(true);
  };

  return (
    <div className="mb-3 rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-sm text-amber-100">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-2">
          <Bell className="mt-0.5 h-4 w-4 shrink-0" />
          <div>
            <div className="font-medium">Recordatorio semanal de exportacion</div>
            <div className="text-xs text-amber-100/80">
              Hoy es lunes. Corresponde descargar los Excels de Ofertas, Clientes e
              Instrumentos desde Admin.
            </div>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <Link
            to="/admin/exports"
            className="inline-flex items-center gap-2 rounded-md border border-emerald-400/40 bg-emerald-500/10 px-3 py-1.5 text-xs font-medium text-emerald-100 hover:bg-emerald-500/20"
          >
            <FileSpreadsheet className="h-3.5 w-3.5" />
            Ir a exportaciones
          </Link>
          <button
            type="button"
            onClick={dismiss}
            className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-amber-400/30 text-amber-100 hover:bg-amber-400/10"
            title="Ocultar por hoy"
            aria-label="Ocultar recordatorio por hoy"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
